import useTimeClockState, {
    IUseTimeClockState,
} from 'hooks/useTimeClockState/useTimeClockState'
import { createContext, useContext } from 'react'

interface ITimeClockPopupContext extends IUseTimeClockState {}

const TimeClockPopupContext = createContext<ITimeClockPopupContext>({
    loading: false,
    timeClock: undefined,
    getCurrentUserTimeClock: async () => {},
    saveActionOfUserTimeClock: async () => {},
})

function TimeClockPopupProvider({ children }: { children: React.ReactNode }) {
    const context = useTimeClockState()

    return (
        <TimeClockPopupContext.Provider value={context}>
            {children}
        </TimeClockPopupContext.Provider>
    )
}

export default TimeClockPopupProvider

export const useTimeClockPopupContext = () => useContext(TimeClockPopupContext)
